import React from 'react';
import UseCaseTemplate from '@/components/use-cases/UseCaseTemplate';

const summary = [
  'White‑label delivery with measurable outcomes',
  'Scale review management across client portfolios',
  'Standardize quality without losing brand voice'
];

const challenges = [
  {
    title: 'Operational load',
    description: 'Review response and reporting often overwhelm account teams.'
  },
  {
    title: 'Inconsistent execution',
    description: 'Different client brands require unique response styles and workflows.'
  },
  {
    title: 'Retention pressure',
    description: 'Agencies need predictable outcomes to protect renewals.'
  }
];

const pillars = [
  {
    title: 'White‑Label Operations',
    description: 'We run review response and reporting under your brand.'
  },
  {
    title: 'Client‑Specific Playbooks',
    description: 'Reusable frameworks customised for each account.'
  },
  {
    title: 'Portfolio Intelligence',
    description: 'Central dashboards to monitor risk and performance.'
  }
];

const timeline = [
  {
    title: 'Onboard',
    description: 'Collect brand guidelines and define response rules per client.'
  },
  {
    title: 'Operate',
    description: 'Run review response workflows and escalation for portfolios.'
  },
  {
    title: 'Report',
    description: 'Monthly performance summaries for client leadership.'
  },
  {
    title: 'Improve',
    description: 'Identify patterns and recommend visibility actions.'
  }
];

const deliverables = [
  'White‑label review response service',
  'Client performance dashboards',
  'Playbook library by industry',
  'Monthly executive summaries for clients'
];

const kpis = [
  'Reduction in average response time',
  'Improved rating velocity for priority clients',
  'Higher renewal confidence and retention'
];

const example = {
  title: 'Example: 15‑client agency portfolio',
  result:
    'Standardized review operations cut response time by 60% and improved average ratings across 9 clients in 12 weeks.'
};

export default function Agencies() {
  return (
    <UseCaseTemplate
      seoTitle="Use Case: Agencies"
      seoDescription="White-label reputation and visibility support for agencies."
      path="/use-cases/agencies"
      title="Agencies"
      subtitle="We help agencies deliver reputation and review outcomes at scale."
      summary={summary}
      challenges={challenges}
      pillars={pillars}
      timeline={timeline}
      deliverables={deliverables}
      kpis={kpis}
      example={example}
    />
  );
}
